import { render, staticRenderFns } from "./Assuntos.vue?vue&type=template&id=8cc18d82&lang=pug&"
import script from "./Assuntos.vue?vue&type=script&lang=js&"
export * from "./Assuntos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports